import React from 'react'
import PropTypes from 'prop-types'
import { brushX as d3BrushX, event as d3Event } from 'd3'
import { useD3Selection, useIsMounted } from 'src/hooks'
import styles from './Brush.scss'

function Brush({ width, height, onBrush, extent }) {
  const [ref, useSelectionEffect] = useD3Selection()

  const brush = React.useMemo(() => d3BrushX(), [])

  const [visible, setVisible] = React.useState(true)

  const isMounted = useIsMounted()

  useSelectionEffect(
    selection => {
      brush
        .extent([
          [0, 0],
          [width, height],
        ])
        .on('brush end', () => {
          if (!d3Event.sourceEvent || d3Event.sourceEvent.type === 'zoom' || d3Event.sourceEvent.sourceEvent) return // ignore brush-by-zoom
          const _extent = d3Event.selection || [0, width]
          // prevent border case when selection is 0 px width
          if (_extent[0] !== _extent[1]) {
            onBrush(_extent)
          }
        })
      brush(selection.selection ? selection.selection() : selection)
    },
    [width, height, onBrush]
  )

  useSelectionEffect(
    selection => {
      const checkVisibility = () => isMounted() && setVisible(extent[0] > 5 || width - extent[1] > 5)
      // show brush
      checkVisibility()
      // move brush
      brush.move(selection, extent)
      // hide brush on transition end if it has less than 5 pixels offset with boundaries
      selection.on('end', checkVisibility)
    },
    [extent, width]
  )

  return <g ref={ref} className={styles.animated + ' ' + (visible ? '' : styles.hidden)} />
}

Brush.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  onBrush: PropTypes.func,
  extent: PropTypes.array,
}

export default React.memo(Brush)
